import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { Toast } from '@/components/notifications-fi/toast-notification-fi/toast-notification-item-fi/ToastNotificationItemFi.vue';
import { useDict } from '@/composables/fischerPlugin';

export const useNotificationStore = defineStore('useNotificationStore', () => {
  const dict = useDict();

  const toastNotifications = ref<Toast[]>([]);
  const snackbarVisible = ref(false);

  const openToastNotification = (notification: Toast) => {
    const newNotification = { ...notification };
    if (!newNotification.name || newNotification.name === '') {
      const randomId = Math.floor(Math.random() * 100);
      newNotification.name = `toast-notification--${randomId}`;
    }
    toastNotifications.value = [...toastNotifications.value, newNotification];
  };

  const openGeneralErrorNotification = () => {
    const newNotification: Toast = {
      name: `general-error-notification--${toastNotifications.value.length}`,
      message: {
        value: dict.get('online-Shop.Global-Labels.Error-Notification'),
      },
      type: 'error',
      icon: 'alert-triangle',
      persist: true,
    };
    toastNotifications.value = [...toastNotifications.value, newNotification];
  };

  const closeToastNotification = (name: string) => {
    toastNotifications.value = toastNotifications.value.filter((x) => x.name !== name);
  };

  const clearToastNotifications = () => {
    toastNotifications.value = [];
  };

  const setSnackbarVisible = (value: boolean) => {
    snackbarVisible.value = value;
  };

  return {
    toastNotifications,
    snackbarVisible,
    openToastNotification,
    openGeneralErrorNotification,
    closeToastNotification,
    clearToastNotifications,
    setSnackbarVisible,
  };
});
